import i18n from '../../i18n.ts';

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
}


export const getCurrentLanguage = (): string => {
  return i18n.language;
}